import React, { FunctionComponent, memo, useMemo } from 'react';
import { DoubleSide } from 'three';
import { ITuple3, ITuple4, IFontTypes, ITextAlignment, ITextReactProps } from '../component-data-structure';
import { IUserData } from '../utils/general';
import CurvedEntity from './CurvedEntity/CurvedEntity';
import CustomBillboard from './CustomBillboard/CustomBillboard';

const TextComp: FunctionComponent<ITextReactProps> = ({
	scale: s,
	color,
	text,
	fontFamily = IFontTypes.Roboto400,
	fontSize = 2,
	fontRgba,
	position,
	rotation,
	textAlignment = ITextAlignment.left,
	onPointerUp,
	onPointerMove,
	onPointerDown,
	onDoubleClick,
    onPointerOut,
    onPointerOver,
	renderOrder,
	curvature,
	id = '',
	raycast,
	castShadow = false,
	receiveShadow = false,
	animationTransformGroupPrefix = '',
    side,
    billboard,
    depthTest = true,
    isCameraOrbiting = false,
    rotateNoBillboardOuterGroup = false
}) => {
	const scale = useMemo(() => s as ITuple3, [s]);
	const zeroPos = useMemo(() => [0, 0, 0], []);
	const userData: IUserData = useMemo(() => ({ renderOrder, contentId: id, depthTest }), [id, renderOrder, depthTest]);

	return (
		<CustomBillboard
			key={'btn_group'}
			userData={userData}
			name={`${animationTransformGroupPrefix}${id}`}
			raycast={raycast}
			position={position as ITuple3}
            rotation={rotation as ITuple3}
			onPointerUp={onPointerUp || undefined}
			onPointerDown={onPointerDown || undefined}
			onPointerMove={onPointerMove || undefined}
			onDoubleClick={onDoubleClick || undefined}
            onPointerOver={onPointerOver || undefined}
            onPointerOut={onPointerOut || undefined}
            follow={billboard?.[0]}
			lockY={!billboard?.[1]}
            isCameraOrbiting={isCameraOrbiting}
            rotateNoBillboardOuterGroup={rotateNoBillboardOuterGroup}
		>
            <group name={`${animationTransformGroupPrefix}inner_${id}`}>
                <CurvedEntity
                    raycast={raycast}
                    key={id}
                    scale={scale as ITuple3}
                    cornerRadius={0}
                    position={zeroPos as ITuple3}
                    renderOrder={renderOrder}
                    opacity={color[3]}
                    curvature={curvature}
                    side={side ?? DoubleSide}
                    colorRgba={color as ITuple4}
                    castShadow={castShadow}
                    receiveShadow={receiveShadow}
                    depthTest={depthTest}
                    text={{
                        value: text,
                        side: side ?? DoubleSide,
                        textAlignment,
                        fontSize,
                        fontFamily,
                        fontRgba: fontRgba as ITuple4,
                        preventPolygonOffset: true
                    }}
                />
            </group>
        </CustomBillboard>
	);
};

export default memo(TextComp);
